/** <quantity-input>: +/- quantity selector used on the PDP for an in-stock single-variant product; the anti-duplicate IIFE disables the hidden zone's field per breakpoint, since a disabled input stays out of the FormData and /cart/add.js must not receive two conflicting `quantity`. */
class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("[data-qty-input]");
    this.addEventListener("click", this.#onClick);
    this.#syncButtons();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.#onClick);
  }

  #onClick = (event) => {
    const step = event.target.closest("[data-qty-step]");
    if (!step || !this.contains(step)) return;
    this.#step(Number(step.dataset.qtyStep));
  };

  // Incrémente/décrémente la quantité, bornée à `min` et au stock disponible (`max`).
  #step(delta) {
    if (!this.input) return;
    const min = Number.parseInt(this.input.min, 10) || 1;
    const max = Number.parseInt(this.input.max, 10);
    const current = Number.parseInt(this.input.value, 10) || min;
    let next = Math.max(min, current + delta);
    // `max` absent (stock non suivi ou survente autorisée) → pas de plafond.
    if (Number.isFinite(max)) next = Math.min(max, next);
    this.input.value = next;
    this.#syncButtons();
  }

  // Désactive « - » à la quantité minimale et « + » au stock disponible.
  #syncButtons() {
    if (!this.input) return;
    const minus = this.querySelector('[data-qty-step="-1"]');
    const plus = this.querySelector('[data-qty-step="1"]');
    const min = Number.parseInt(this.input.min, 10) || 1;
    const max = Number.parseInt(this.input.max, 10);
    const current = Number.parseInt(this.input.value, 10) || min;
    if (minus) minus.disabled = current <= min;
    if (plus) plus.disabled = Number.isFinite(max) && current >= max;
  }
}

if (!customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}

// --- Un seul name="quantity" soumis (colonne info desktop vs barre sticky mobile) ---
(function () {
  const form = document.querySelector("product-form-component form");
  if (!form) return;

  const mq = window.matchMedia("(max-width: 750px)");

  function syncActiveQuantity() {
    form.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      const inSticky = input.closest(".product_sticky_cta") !== null;
      // Zone visible → champ actif ; zone masquée → champ désactivé (hors FormData).
      input.disabled = mq.matches ? !inSticky : inSticky;
    });
  }

  mq.addEventListener("change", syncActiveQuantity);
  syncActiveQuantity();
})();
